import React from 'react';
import { Link } from 'react-scroll';
import Stylist from '../../assets/Images/stylist_image_1.webp';
import Stylist2 from '../../assets/Images/stylist_image_2.webp';
import Stylist3 from '../../assets/Images/stylist_image_3.webp';
import './Stylists.scss';

const Stylists = ({t}) => {
	return (
		<>
			<section id="stylists" className="stylists">
				<h3>{t('Stylists.1')}</h3>
				<div className="stylist_container">
					<div className="single_stylist" id="stylist_1">
						<Link to="contact" spy={true} smooth={true} offset={-50} duration={800}>
							<img src={Stylist3} alt="Olga, salon manager" width={1200} height={1616} loading="lazy" />
							<p>Olga (Mgr)</p>
						</Link>
					</div>
					<div className="single_stylist" id="stylist_2">
						<Link to="contact" spy={true} smooth={true}  offset={-50} duration={800}>
							<img src={Stylist2} alt="Jamilette, stylist" width={1200} height={1616} loading="lazy" />
							<p>Jamilette (Stylst)</p>
						</Link>
					</div>
					<div className="single_stylist" id="stylist_3">
						<Link to="contact" spy={true} smooth={true}  offset={-50} duration={800}>
							<img src={Stylist} alt="Trini, stylist" width={1200} height={1616} loading="lazy" />
							<p>Trini (Stylst)</p>
						</Link>
					</div>
				</div>
			</section>
		</>
	)
}

export default Stylists
